import { render, staticRenderFns } from "./LeaderTabs.vue?vue&type=template&id=2de255a0&scoped=true&"
import script from "./LeaderTabs.vue?vue&type=script&lang=js&"
export * from "./LeaderTabs.vue?vue&type=script&lang=js&"
import style0 from "./LeaderTabs.vue?vue&type=style&index=0&id=2de255a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de255a0",
  null
  
)

export default component.exports